import { createRoot } from 'react-dom/client';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import MemberSignupButton from './MemberSignupButton';

class BilberryMemberSignupButton extends BilberryCustomElement {
    protected renderWidget(): void {
        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <MemberSignupButton />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-member-signup-button', BilberryMemberSignupButton);
}
